// IE 2026 09 22 / ODOO-… (заказ Игоря 22.09): полосы-интервалы дат в ячейках грида. Слова Игоря: «когда у нас есть период с / период по —
// вычислить минимальные и максимальные периоды для всех строк в этой колонке и визуализировать в виде интервала Ганта период действия;
// переход между ячейкой "период с" и ячейкой "период по" — это текущая фактическая дата; интервалы ненавязчивые, главное — читаемость
// самих дат»; «такой же подход — в колонке с просто датой (дата изменения в Meta): min / max и в каждой ячейке интервал, чтобы было
// видно её относительно других; можно как колонка гистограммы, ось X — нижний бордюр ячейки»; «прижать к нижнему бордюру, за текстом,
// при наведении — небольшое увеличение».
// Чистая логика (без DOM): роли колонок «с / по» по имени поля или заголовку, пары, шкалы по строкам, геометрия полосы в ячейке.
// Рисует AttrGrid (dateBar_paint), CSS — .cell-date-bar. Юнит: handoff-files/date-bars-2026-09-22/dateBars.test.mjs.

const FROM_TOKENS = new Set(['from', 'start', 'begin', 'since', 'starts', 'begins'])
const TO_TOKENS = new Set(['to', 'end', 'till', 'until', 'ends', 'finish'])
const DAY = 86400000

// значение ячейки → миллисекунды; '' / null / 0001-01-01 → null; 3000-01-01 (и любой год ≥ 2999) — «без конца» → Infinity
export function dateBar_parse(v) {
    if (v == null || v === '') return null
    if (v instanceof Date) return isNaN(v.getTime()) ? null : v.getTime()
    if (typeof v === 'number') return isFinite(v) ? v : null
    const s = String(v).trim()
    if (!s) return null
    const m = /^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2})(?::(\d{2})(?:\.(\d+))?)?)?/.exec(s)
    if (!m) { const t = Date.parse(s); return isNaN(t) ? null : t }
    const y = +m[1]
    if (y <= 1) return null              // 0001-01-01T00:00:00 — «пусто» бэка
    if (y >= 2999) return Infinity       // 3000-01-01 — «действует бессрочно»
    const ms = m[7] ? Math.round(+('0.' + m[7]) * 1000) : 0
    return new Date(y, +m[2] - 1, +m[3], +(m[4] || 0), +(m[5] || 0), +(m[6] || 0), ms).getTime()
}

const tokens = (s) => String(s || '').replace(/([a-z\d])([A-Z])/g, '$1_$2').toLowerCase().split(/[^a-z\d]+/).filter(Boolean)

// роль колонки по имени поля (последний сегмент пути: date_from, valid_to, start_date, end_date, from, to), иначе по заголовку
// (Valid From / Planning end / Start date); stem — общая часть, по которой ищется пара (с префиксом пути: doc.date_from ↔ doc.date_to)
export function dateBar_role(binding, title) {
    const b = String(binding || '')
    const dot = b.lastIndexOf('.')
    const prefix = dot >= 0 ? b.slice(0, dot + 1) : ''
    const byTokens = (toks, pre) => {
        if (!toks.length) return null
        const first = toks[0], last = toks[toks.length - 1]
        if (FROM_TOKENS.has(last)) return { role: 'from', stem: pre + toks.slice(0, -1).join('_') }
        if (TO_TOKENS.has(last)) return { role: 'to', stem: pre + toks.slice(0, -1).join('_') }
        if (toks.length > 1 && FROM_TOKENS.has(first)) return { role: 'from', stem: pre + toks.slice(1).join('_') }
        if (toks.length > 1 && TO_TOKENS.has(first)) return { role: 'to', stem: pre + toks.slice(1).join('_') }
        return null
    }
    return byTokens(tokens(b.slice(dot + 1)), prefix) || byTokens(tokens(title), 't:' + prefix)
}

// план: cols — датные колонки в порядке показа [{ binding, title, index, mode }] (mode — настройка колонки 'date-bar':
// false — без полосы, 'tick' | 'bar' — одиночная как колонка гистограммы / как полоса от min, 'interval' — только парой).
// Результат: { byBinding: { binding: { kind: 'from' | 'to' | 'single', key, pair, mode } }, pairs: [key…], singles: [binding…] }
export function dateBar_plan(cols) {
    const byBinding = {}, pairs = [], singles = []
    const roles = cols.map(c => ({ ...c, r: c.mode === false ? null : dateBar_role(c.binding, c.title) }))
    const used = new Set()
    // сначала пары: колонка «с» + ближайшая колонка «по» с той же основой (сначала правее, иначе левее)
    for (const c of roles) {
        if (c.mode === false || !c.r || c.r.role !== 'from' || used.has(c.binding)) continue
        const cands = roles.filter(o => o !== c && !used.has(o.binding) && o.mode !== false && o.r && o.r.role === 'to' && o.r.stem === c.r.stem)
        const to = cands.filter(o => o.index > c.index).sort((a, b) => a.index - b.index)[0] || cands.sort((a, b) => b.index - a.index)[0]
        if (!to) continue
        const key = c.r.stem || c.binding
        byBinding[c.binding] = { kind: 'from', key, pair: to.binding, mode: 'interval' }
        byBinding[to.binding] = { kind: 'to', key, pair: c.binding, mode: 'interval' }
        used.add(c.binding); used.add(to.binding); pairs.push(key)
    }
    // остальные — одиночные (в т.ч. «с» / «по» без пары: их партнёр скрыт или не показан)
    for (const c of roles) {
        if (c.mode === false || used.has(c.binding) || c.mode === 'interval') continue   // 'interval' — «только парой», а пары нет
        byBinding[c.binding] = { kind: 'single', key: c.binding, mode: c.mode === 'bar' ? 'bar' : 'tick' }
        used.add(c.binding); singles.push(c.binding)
    }
    return { byBinding, pairs, singles }
}

// шкалы по строкам: rows — сырые строки, get(row, binding) → значение, seam — граница «с / по» (мс, начало дня).
// Пара: левая половина [lmin … seam] (ячейка «с»), правая [seam … rmax] (ячейка «по»); одиночная: [min … max].
export function dateBar_scales(rows, plan, get, seam) {
    const acc = {}
    const touch = (key) => acc[key] || (acc[key] = { min: Infinity, max: -Infinity, n: 0 })
    const bump = (a, t) => { if (t == null) return; a.n++; if (!isFinite(t)) return; if (t < a.min) a.min = t; if (t > a.max) a.max = t }
    const entries = Object.entries(plan.byBinding)
    for (const row of rows) {
        if (!row) continue
        for (const [binding, e] of entries) bump(touch(e.key), dateBar_parse(get(row, binding)))
    }
    const pairs = {}, singles = {}
    for (const key of plan.pairs) {
        const a = acc[key]
        if (!a || !a.n) continue
        const lmin = Math.min(isFinite(a.min) ? a.min : seam, seam - DAY)
        const rmax = Math.max(isFinite(a.max) ? a.max : seam, seam + DAY)
        pairs[key] = { lmin, seam, rmax }
    }
    for (const binding of plan.singles) {
        const a = acc[binding]
        if (!a || !a.n || !isFinite(a.min)) continue
        singles[binding] = { min: a.min, max: a.max }
    }
    return { pairs, singles, seam }
}

// геометрия полосы в ячейке шириной w: { x, w, cls } либо null (полосы нет). pad — поле от краёв для шкалы одиночной колонки.
//   single tick — «колонка гистограммы» в точке даты; single bar — полоса от min до даты;
//   from — левая половина линии времени [lmin … seam]: интервал строки, попавший в прошлое; до правого края, если действует и после seam;
//   to   — правая половина [seam … rmax]: часть после seam; от левого края, если начался раньше; открытый конец — до края с затуханием.
export function dateBar_geom(entry, scales, values, w, pad = 2) {
    if (!entry || !(w > 0)) return null
    const inner = Math.max(1, w - 2 * pad)
    if (entry.kind === 'single') {
        const sc = scales.singles[entry.key]
        const t = dateBar_parse(values.value)
        if (!sc || t == null || !isFinite(t)) return null
        const x = sc.max > sc.min ? pad + (t - sc.min) / (sc.max - sc.min) * inner : (entry.mode === 'bar' ? pad + inner : w / 2)
        if (entry.mode === 'bar') return { x: 0, w: Math.max(2, x), cls: 'is-bar' }
        return { x: Math.max(0, Math.min(w - 2, x - 1)), w: 2, cls: 'is-tick' }
    }
    const sc = scales.pairs[entry.key]
    if (!sc) return null
    let a = dateBar_parse(values.from), b = dateBar_parse(values.to)
    if (a == null && b == null) return null
    if (a == null) a = -Infinity
    if (b == null) b = Infinity
    if (a > b) return null
    const cls = []
    if (entry.kind === 'from') {
        if (a >= sc.seam) return null                       // начинается в будущем — целиком в ячейке «по»
        const s = Math.max(a, sc.lmin), e = Math.min(b, sc.seam)
        const span = sc.seam - sc.lmin
        const x0 = a === -Infinity ? 0 : pad + (s - sc.lmin) / span * inner
        const x1 = b >= sc.seam ? w : pad + (e - sc.lmin) / span * inner
        if (a === -Infinity) cls.push('is-open-l')
        if (b >= sc.seam) cls.push('is-cont-r')
        return { x: x0, w: Math.max(2, x1 - x0), cls: cls.join(' ') }
    }
    // kind === 'to'
    if (b <= sc.seam) return null                           // кончился раньше seam — целиком в ячейке «с»
    const s = Math.max(a, sc.seam), e = Math.min(b, sc.rmax)
    const span = sc.rmax - sc.seam
    const x0 = a <= sc.seam ? 0 : pad + (s - sc.seam) / span * inner
    const x1 = b === Infinity ? w : pad + (e - sc.seam) / span * inner
    if (a <= sc.seam) cls.push('is-cont-l')
    if (b === Infinity) cls.push('is-open-r')
    return { x: x0, w: Math.max(2, x1 - x0), cls: cls.join(' ') }
}

// начало дня (локальное) для seam
export function dateBar_dayStart(t) { const d = new Date(t == null ? Date.now() : t); d.setHours(0, 0, 0, 0); return d.getTime() }
